import PaymentType from "../../Models/PaymentType";

export const GET_PAYMENT_TYPES = "PaymentType/getPaymentTypes";

export interface PaymentTypeReducerType {
  paymentTypes: PaymentType[];
  paymentTypesOptions: any;
}
